import React, { useState } from 'react';
import styles from './styles/UserSubmittedBody.module.css';
import { useScenario } from '../../../context/ScenarioContext';

const UserSubmittedBody = ({ situation, setCurrentSituationId, isScenarioLogged, preview, assignmentId, universalLock, userLock }) => {

    const [activeTab, setActiveTab] = useState('text');
    const [userInput, setUserInput] = useState('');
    const { submitDecision } = useScenario();

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    // Both submit and skip advance to the next situation; the live teacher view
    // picks the move up from ViewScenario's progress effect.
    const advance = async (inputValue) => {
        const nextChoice = situation.choices.find(choice => choice.nextSituation && choice.nextSituation._id);

        if (!nextChoice) {
            console.warn("No next situation found for this action.");
            return;
        }

        if (isScenarioLogged && !preview) {
            await submitDecision({
                situationId: situation._id,
                choiceId: nextChoice._id,
                userInput: inputValue,
                type: 'input',
                nextSituationId: nextChoice.nextSituation._id,
                assignmentId,
                fromToC: false
            });
        }

        setCurrentSituationId(nextChoice.nextSituation._id);
        setUserInput('');
    };

    const handleSkipClick = () => advance('[SKIP]');
    const handleSubmit = () => advance(userInput);

    return (
        <div className={styles.container}>
            <div className={styles.tabs}>
                <div
                    className={`${styles.tab} ${activeTab === 'text' ? styles.active : ''}`}
                    onClick={() => handleTabClick('text')}
                >
                    Enter Text
                </div>
                <div
                    className={`${styles.tab} ${activeTab === 'audio' ? styles.active : ''}`}
                    onClick={() => handleTabClick('audio')}
                >
                    Record Audio
                </div>
            </div>
            <div className={styles.tabContent}>
                {activeTab === 'text' ? (
                    <textarea
                        className={styles.textarea}
                        placeholder="Enter your text here..."
                        value={userInput}
                        onChange={(e) => setUserInput(e.target.value)}
                    ></textarea>
                ) : (
                    <div className={styles.recordAudio}>RECORD AUDIO (to be added)</div>
                )}
            </div>

            <div className={styles.buttonContainer}>
                <button className={`${styles.button} ${(universalLock || userLock) ? styles.disabledChoice : ''}`} onClick={handleSubmit} disabled={universalLock || userLock}>Submit</button>
                <button className={`${styles.button} ${(universalLock || userLock) ? styles.disabledChoice : ''}`} onClick={handleSkipClick} disabled={universalLock || userLock}>Skip</button>
            </div>
        </div>
    );
};

export default UserSubmittedBody;
